import React, { useState, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from '../../../../../components/TabPanel';
import { useRegisterAdded } from '../../../../../../../../../hooks/registerAdded';

import Detalhes from './Detalhes';
import Complementos from './Complementos';

import { MenuOptionButton } from '../../../../../../styles';
import {
  CloseButton,
  DrawerTitle,
  DrawerContainer,
} from '../../../../../drawer_styles';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

interface ComplementoType {
  id: number;
  empresa_id: number;
  descricao: string;
  qtd_min: number;
  qtd_max: number;
  complemento_obrigatorio: boolean;
  tipo: number;
  imagem?: File;
  ativo: boolean;
}

interface EditComplementoProps {
  complemento: ComplementoType;
  id_complemento: number;
  title: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const Complemento: React.FC<EditComplementoProps> = ({
  complemento, id_complemento, title
}) => {
  const [value, setValue] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const classes = useStyles();
  const {
    handleSetComplementoDrawerClosed,
    complementoDrawerClosed
  } = useRegisterAdded();

  useEffect(() => {
    if (complementoDrawerClosed) {
      setValue(0);
      setIsOpen(false);
      handleSetComplementoDrawerClosed(false);
    }
  }, [complementoDrawerClosed, handleSetComplementoDrawerClosed]);

  const handleChange = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  const toggleDrawer = (open: boolean) => () => {
    setIsOpen(open);
  };

  return (
    <>
      <MenuOptionButton onClick={toggleDrawer(true)}>Editar</MenuOptionButton>

      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Edição do Complemento {title}</h1>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} />
                    <Tab label="Complementos" {...a11yProps(1)} />
                  </Tabs>
                </AppBar>

                <TabPanel value={value} index={0}>
                  <Detalhes complemento={complemento} />
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <Complementos id_complemento={id_complemento} />
                </TabPanel>
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default Complemento;
